import { FC } from "react";
import { generatePath } from "react-router-dom";
import { NoDataMessage } from "shared/components/feedback/NoDataMessage/NoDataMessage";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import { BUS } from "shared/utils/routes";
import {
  DayPlanListBus,
  DayPlanListItemBus,
} from "features/CenterContent/shared/DayPlanListBus";

type ShiftScheduleProps = {
  vehicle: AlternativeTransportVehicle;
};

export const ShiftSchedule: FC<ShiftScheduleProps> = ({ vehicle }) => {
  const { workShiftPlan } = vehicle;

  if (
    !workShiftPlan?.workShiftTrips ||
    workShiftPlan.workShiftTrips.length === 0
  ) {
    return <NoDataMessage reason="Det finnes ikke skiftplan denne bussen" />;
  }

  return (
    <DayPlanListBus>
      {workShiftPlan.workShiftTrips.map((trip) => {
        const isCurrentTrip = trip.vehicleUuid === vehicle.id;
        return (
          <DayPlanListItemBus
            isSelected={isCurrentTrip}
            isBus
            to={generatePath(BUS, {
              vehicleUuid: trip.vehicleUuid,
            })}
            key={trip.vehicleUuid}
            title={trip.trainIds.join(", ") ?? "Avgang"}
            subTitle={trip.tripPatternId}
            fromLocation={trip.originStopName}
            toLocation={trip.destinationStopName}
            startTime={trip.scheduledDepartureTimeOrigin}
            endTime={trip.scheduledArrivalTimeDestination}
          />
        );
      })}
    </DayPlanListBus>
  );
};
